import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Container, Navbar, Nav, Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const PublicLayout = ({ children }) => {
  const { isAuthenticated, user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const isProveedor = isAuthenticated && Number(user?.rol) === 2;

  const razonSocialProveedor =
    (user?.razon_social && String(user.razon_social).trim()) ||
    (user?.nombre_completo && String(user.nombre_completo).trim()) ||
    user?.email ||
    '';

  const navItems = [
    { to: '/', label: 'Inicio', icon: 'bi-house' },
    { to: '/mis-cotizaciones', label: 'Mis postulaciones', icon: 'bi-file-earmark-text' },
    { to: '/mis-ordenes', label: 'Mis órdenes', icon: 'bi-file-earmark-richtext' },
    { to: '/perfil', label: 'Mi perfil', icon: 'bi-person' },
  ];

  const isActive = (item) => {
    if (item.to === '/') {
      return location.pathname === '/';
    }
    return location.pathname === item.to || location.pathname.startsWith(`${item.to}/`);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="min-vh-100 d-flex flex-column">
      {isProveedor && (
        <>
          <div
            style={{
              height: '4px',
              background: 'linear-gradient(90deg, #2b3e53 0%, #3498db 50%, #2e7d32 100%)',
            }}
            aria-hidden
          />
          <Navbar
            expand="lg"
            bg="white"
            className="portal-proveedor-nav border-bottom shadow-sm py-2"
            style={{ position: 'sticky', top: 0, zIndex: 1030 }}
          >
            <Container style={{ maxWidth: 1200 }}>
              <Navbar.Brand as={Link} to="/" className="d-flex align-items-center py-1 me-lg-3">
                <img
                  src="/LOGO-DIRESA.png"
                  alt="DIRESA"
                  style={{ height: '44px', width: 'auto', objectFit: 'contain' }}
                />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="portal-proveedor-nav" className="border-secondary-subtle" />
              <Navbar.Collapse id="portal-proveedor-nav">
                <Nav className="me-auto my-2 my-lg-0 gap-lg-1">
                  {navItems.map((item) => (
                    <Nav.Link
                      key={item.to}
                      as={Link}
                      to={item.to}
                      active={isActive(item)}
                      className={isActive(item) ? 'active' : ''}
                    >
                      <i className={`bi ${item.icon} me-1`} />
                      {item.label}
                    </Nav.Link>
                  ))}
                </Nav>
                <div className="d-flex flex-column flex-lg-row align-items-lg-center gap-2 ms-lg-auto mt-2 mt-lg-0">
                  {razonSocialProveedor && (
                    <div
                      className="portal-proveedor-nombre text-lg-end px-lg-2 text-truncate"
                      style={{ maxWidth: 'min(100%, 24rem)' }}
                      title={razonSocialProveedor}
                    >
                      <span className="d-none d-lg-inline text-secondary small me-1">Proveedor:</span>
                      <span className="fw-semibold text-dark">{razonSocialProveedor}</span>
                    </div>
                  )}
                  <Button
                    type="button"
                    variant="link"
                    className="btn-cerrar-sesion text-decoration-none align-self-lg-center"
                    onClick={handleLogout}
                  >
                    <i className="bi bi-box-arrow-right me-1" />
                    Cerrar sesión
                  </Button>
                </div>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </>
      )}
      <div className="flex-grow-1">{children}</div>
    </div>
  );
};

export default PublicLayout;
